import { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { Link, useNavigate } from 'react-router-dom';
import EmployeeAlias from "./EmployeeAlias";
import OpenPositions from './OpenPositions';
import employeeInfoAtom from '../atoms/employeeInfoAtom';
import { url } from '../utils/config';
import axios from 'axios';
import { btnOne, btnSmall, title } from '../utils/style';
import Button from '../reusable_components/Button';

function EmployeeTree() {
    const navigate = useNavigate();

    const [ profile, setProfile ] = useRecoilState(employeeInfoAtom);
    const [ employeeData, setEmployeeData ] = useState([
        {name: 'Tommy Shelby', position: 'CEO', department: ''},
        {name: 'Jovan Terry', position: 'Manager', department: 'Sales'},
        {name: 'Clare Atkins', position: 'Manager', department: 'Services'},
        {name: 'Nicholas Bridges', position: 'Manager', department: 'Marketing'},
        {name: 'Mario Carey', position: 'Manager', department: 'Office'},
        {name: 'Raina Foster', position: 'Executive', department: 'Sales'},
        {name: 'Hassan Harris', position: 'Technician', department: 'Services'},
        {name: 'Lilia Villa', position: 'Executive', department: 'Office'},
        {name: 'Brice Bass', position: 'Executive', department: 'Sales'},
        {name: 'Kaiya Irwin', position: 'Executive', department: 'Marketing'},
        {name: 'Nayeli Peterson', position: 'Executive', department: 'Office'},
        {name: 'Gary Mckinney', position: 'Technician', department: 'Services'},
        {name: 'Pablo Curry', position: 'Technician', department: 'Services'},
        {name: 'Ryleigh Blanchard', position: 'Executive', department: 'Marketing'},
        {name: 'Reese Arroyo', position: 'Technician', department: 'Services'},2.
    ])


    function managersList() {
        let data = employeeData.filter((e) => e.position === 'Manager');
        return data;
    }

    async function fetchProfileData(id) {
        try {
            const reqUrl = url + '/technician_profile/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data);
            setEmployeeData(data);
            navigate('/employee/profile')
        } catch (error) {
            console.log(error)
        }
    }

    return(
        <div className='flex w-full'>
            <div className="w-full">
                {/* <div className="flex justify-center">
                    {
                        employeeData.map( e => e.department === '' ? <EmployeeAlias name={e.name} position={e.position} /> : null)
                    }
                </div> */}
                <div className='flex justify-between items-center pb-4'>
                    <div className={title}>Employee</div>
                    <span>
                        <Button 
                            className={btnOne}
                            name={<Link to={'/employee/position'}>Open Positions</Link>}
                        />
                    </span>
                </div>
                <div className="flex justify-between bg-gray-50 p-4"> 
                    {
                        managersList().map((m, i) => <div key={i}>
                            <div onClick={() => fetchProfileData(m)}><EmployeeAlias name={m.name} position={m.department + ' ' + m.position} /></div>
                            {
                                employeeData.filter(e => e.position !== 'Manager' && e.department === managersList()[i].department).map((em, ind) => 
                                    <div key={ind} onClick={() => fetchProfileData(em)}>
                                        <div className="flex justify-center">
                                            <div className="h-12 bg-customOne w-1"></div>
                                        </div>
                                        <EmployeeAlias name={m.name} position={m.department + ' ' + m.position} />
                                    </div>
                                )
                            }
                        </div>)
                    }
                </div>
            </div>
            {/* <OpenPositions /> */}
        </div>
    )
}
export default EmployeeTree;
